var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9238 19.0866L14.5214 19.0744L22.3736 11.2972C22.6817 10.9891 22.8513 10.5798 22.8513 10.1445C22.8513 9.70919 22.6817 9.29995 22.3736 8.9918L21.0806 7.69886C20.4643 7.08256 19.389 7.08582 18.7776 7.69641L10.9238 15.4752V19.0866ZM19.9279 8.85158L21.2233 10.1421L19.9214 11.4317L18.6284 10.1396L19.9279 8.85158ZM12.5543 16.1551L17.47 11.2858L18.763 12.5788L13.848 17.4464L12.5543 17.4505V16.1551Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29328 22.3368H20.7063C21.6055 22.3368 22.3368 21.6055 22.3368 20.7063V13.64L20.7063 15.2705V20.7063H11.8677C11.8465 20.7063 11.8245 20.7145 11.8033 20.7145C11.7764 20.7145 11.7495 20.7071 11.7218 20.7063H9.29328V9.29328H14.8751L16.5055 7.66284H9.29328C8.39409 7.66284 7.66284 8.39409 7.66284 9.29328V20.7063C7.66284 21.6055 8.39409 22.3368 9.29328 22.3368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b38e2da26773f7bdae74879232d58256.svg";
export { ForwardRef as ReactComponent };